import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import { NavLink, Outlet } from "react-router-dom";

const links = [
  { title: "Información General", to: "datos-generales" },
  { title: "Establecimientos", to: "establecimientos" },
  { title: "Contactos", to: "contactos" },
  { title: "Encargados", to: "encargados" },
  { title: "Actividad Económica", to: "actividad-economica" },
  { title: "Afiliación", to: "afiliacion" },
  { title: "Archivos Adjuntos", to: "archivos-adjuntos" },
];

function getClassName(props) {
  return `nav-link disabled ${
    props.isActive ? "active border-bottom border-dark" : ""
  }`;
}

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid">
        {/* <button
          className="navbar-toggler ms-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav2"
          aria-controls="navbarNav2"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button> */}

        <div className="collapse navbar-collapse" id="navbarNav2">
          <ul className="navbar-nav">
            {links.map((navlink, i) => (
              <li className="nav-item" key={i}>
                <NavLink className={getClassName} to={navlink.to}>
                  {navlink.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export function EmpresaLayout() {
  const { reset } = useEmpresa();

  return (
    <Container padding={4}>
      <div className="d-flex justify-content-between p-2 border-bottom">
        <h4>
          <strong>Formulario de solicitud de inscripción</strong>
        </h4>

        <button className="btn btn-warning me-2" onClick={reset}>
          Reiniciar
        </button>
      </div>

      {/* navegación del formulario */}
      <Navbar />

      <Container padding={2}>
        <Row>
          <Column>
            <Outlet />
          </Column>
        </Row>
      </Container>
    </Container>
  );
}
